import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ShopMenuApi } from 'api';
import type { ShopMenu } from 'api/methods/ShopMenuApi';

/**
 * [ShopMenu] Query key 생성
 * --
 */
export const shopMenuQueryKeys = createQueryKeys('shop_menu', {
  getShopMenu: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getShopMenus: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [ShopMenu] 매장 메뉴 내역 전체 조회
 * --
 */
export const useGetShopMenus = (
  params?: {
    [key: string]: string | number;
  },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: shopMenuQueryKeys.getShopMenus(params).queryKey,
    queryFn: () => ShopMenuApi.getShopMenus(params),
    ...options,
  });
  return data;
};

/**
 * [ShopMenu] 매장 메뉴 내역 상세 조회
 * --
 */
export const useGetShopMenu = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: shopMenuQueryKeys.getShopMenu(idx, params).queryKey,
    queryFn: () => ShopMenuApi.getShopMenu(idx, params),
  });

  return data;
};

/**
 * [ShopMenu] 매장 메뉴 내역 생성
 * --
 */
export const useCreateShopMenu = (body: ShopMenu) => {
  const { mutateAsync: createShopMenu, ...result } = useMutation({
    mutationFn: (variables: ShopMenu) => ShopMenuApi.createShopMenu(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createShopMenu, ...result };
};

/**
 * [ShopMenu] 매장 메뉴 내역 수정
 * --
 */
export const useUpdateShopMenu = (body: ShopMenu) => {
  const { mutateAsync: updateShopMenu, ...result } = useMutation({
    mutationFn: (variables: ShopMenu) => ShopMenuApi.updateShopMenu(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateShopMenu, ...result };
};

/**
 * [ShopMenu] 매장 메뉴 내역 삭제
 * --
 */
export const useDeleteShopMenu = (idx: number) => {
  const { mutateAsync: deleteShopMenu, ...result } = useMutation({
    mutationFn: (variables: number) => ShopMenuApi.deleteShopMenu(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteShopMenu, ...result };
};
